<template>
  <div class="home-ai">
    <!-- <p class="color-title"><i class="icon-ai"></i>精研识人治事</p>
        <p class="sub-title">人工智能驱动治理，数字中台承载业务</p> -->
    <p class="hy-title">技术能力</p>
    <div class="ai-content">
      <div class="ai-l">
        <p class="tag">AI+创新</p>
        <p class="ai-title" style="text-indent: 0">浙大“大先生”组工AI基座</p>
        <p class="ai-desc">
          研AI基座，多场景应用，可私有化部署。实现干部选人用人、业务经办从靠经验到AI赋能的转型。
        </p>
        <img
          style="width: 100%; margin-top: 4px"
          src="@/assets/images/ai-bg1.png"
          alt=""
        />
      </div>
      <div class="ai-r">
        <div class="ai-r-t">
          <div>
            <p class="tag tag1">数据服务</p>
            <p class="ai-title">“海川”数据中台</p>
            <p class="ai-desc">
              数据融合共享，数据资产管理，通过数据治理，驱动组工一体化平台建设，支撑数据分析与决策。
            </p>
          </div>
          <!-- <img src="@/assets/images/ai-bg2.png" alt=""> -->
        </div>
        <div class="ai-r-b">
          <div class="ai-r-b-l">
            <p class="tag tag2">业务融合</p>
            <p class="ai-title">“经纬”业务中台</p>
            <p class="ai-desc" style="font-size: 26px; line-height: 1.2">
              标准化业务能力，统一身份权限，驱动多系统高效协同。
            </p>
          </div>
          <div class="ai-r-b-r">
            <p class="tag tag3">技术支撑</p>
            <p class="ai-title">“磐石”技术中台</p>
            <p class="ai-desc" style="font-size: 26px; line-height: 1.2">
              灵活通用组件，统一技术体系，提供底层技术支撑。。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeAi",
  data() {
    return {
      aiList: [],
    };
  },
  methods: {
    getAiList() {
      this.aiList = [
        { title: "AI应用", value: "1" },
        { title: "AI应用", value: "2" },
        { title: "AI应用", value: "3" },
      ];
    },
  },
};
</script>

<style lang="less">
.home-ai {
  background-color: rgba(255, 255, 255, 1);
  padding-top: 64px;
  .color-title {
    height: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-ai {
    display: inline-block;
    width: 70px;
    height: 54px;
    margin-right: 8px;
    background-image: url("@/assets/images/ai-icon.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
  .bg {
    padding: 30px 18px;
    border-radius: 10px;
    background: rgba(247, 250, 255, 1);
    border: 1px solid rgba(255, 255, 255, 1);
  }
  .ai-content {
    height: 644px;
    margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .ai-l {
      width: 812px;
      height: 100%;
      .bg;
    }
    .ai-r {
      width: 808px;
      height: 100%;
      margin-left: 20px;
      .ai-r-t {
        height: 308px;
        display: flex;
        align-items: center;
        .bg;
        img {
          display: block;
          width: 328px;
          margin-left: 20px;
        }
      }
      .ai-r-b {
        height: 314px;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        .ai-r-b-l {
          width: calc(50% - 10px);
          height: 100%;
          .bg;
        }
        .ai-r-b-r {
          width: calc(50% - 10px);
          height: 100%;
          .bg;
        }
      }
    }
    .tag {
      width: 194px;
      height: 48px;
      font-size: 0;
      background-image: url("@/assets/images/tag-txt-1.png"),
        url("@/assets/images/tag-bg-1.png");
      background-repeat: no-repeat;
      background-position: center, center;
      background-size: contain, 100% 100%;

      &.tag1 {
        background-image: url("@/assets/images/tag-txt-2.png"),
          url("@/assets/images/tag-bg-2.png");
      }
      &.tag2 {
        background-image: url("@/assets/images/tag-txt-3.png"),
          url("@/assets/images/tag-bg-3.png");
      }
      &.tag3 {
        background-image: url("@/assets/images/tag-txt-4.png"),
          url("@/assets/images/tag-bg-4.png");
      }
    }
    .ai-title {
      height: 44px;
      margin-top: 30px;
      font-size: 38px;
      font-weight: 700;
      letter-spacing: 5px;
      line-height: 40px;
      color: rgba(56, 73, 89, 1);
      text-indent: -0.5em;
      font-family: "PingFang SC", "黑体";
      span {
        color: rgba(244, 54, 8, 1);
      }
    }
    .ai-desc {
      font-family: "PingFang SC";
      margin-top: 12px;
      font-size: 28px;
      line-height: 38px;
      font-weight: 400;
      height: 156px;
      color: rgba(106, 106, 106, 1);
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
